export default __webpack_public_path__ + "static/vision-icon-9880be2f26598d62d0bbbb7584ba212d.png";